/* Run 07 gout quiz — interaction model cloned from the reference quiz.js:
   Next-only advance (no auto-advance), per-step validation that blocks, back arrow from step 2,
   progress = step / steps (0% on first paint, as the reference renders).
   Last step = buy box (package cards + Subscribe & Save, prices switch live). Its button starts the ring loader
   (time-driven 0 → target %), then:
     mode "reveal":   reveal = trust page (body.rq-revealed shows the discount bar + the buy-page sections placed after the quiz
                      in the template; radiancy-quiz-gout.css hides them otherwise). Checkout button — the reveal card's
                      [data-rq-checkout] and any [data-rb-checkout] on the page (reviews section), one shared function and
                      state: /cart/clear.js through a hidden iframe's fetch (nothing needs to observe it) → for a pack
                      with free bottles (cfg.freeVariantId + tier.free), the $0.00 free-bottle line, one-time, through
                      the same iframe fetch (a display line: it must not reach Meta as a second, $0 AddToCart) →
                      /cart/add.js of the paid pack through the page's own window.fetch (Shopify's instrumentation emits
                      product_added_to_cart → Meta AddToCart; tracking law rule 1) → /checkout immediately (rule 2),
                      carrying utm_* / fbclid. The paid line carries checkout-visible properties: bottle count, savings,
                      guarantee. UpCart never opens (openOnAddToCart=false here, #upCart hidden by radiancy-buy.css).
     mode "redirect": ready screen → buy page URL + incoming query string (minus drop list) + q1..qN + bottle.
     mode "checkout": (run 08 VSL quiz) ready screen → the same add path as the reveal button for the Q5 pack and
                      Subscribe & Save choice (two-way toggle with sub_style = toggle) → /checkout, no reveal.
   Microsoft Clarity (app embed on the page): clarity('set', key, value) per answered step,
   clarity('event', quiz_started | quiz_step_N | quiz_completed | quiz_checkout_click).
   Answers also go to sessionStorage "radiancy_quiz". */
(function () {
  'use strict';

  function clarity() {
    // Queue shim: identical to the Clarity snippet, so calls made before clarity.js loads are replayed by it.
    window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
    try { window.clarity.apply(window, arguments); } catch (e) { /* never break the quiz on analytics */ }
  }

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function fill(template, map) {
    return String(template || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; });
  }
  function slice(list) { return Array.prototype.slice.call(list); }

  function init(root) {
    if (!root || root.dataset.rqReady === '1') return;
    root.dataset.rqReady = '1';

    var cfgEl = root.querySelector('[data-rq-config]');
    var cfg = {};
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[rq] bad config', e); }
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    var incoming = window.location.search.substring(1);
    var questions = slice(root.querySelectorAll('[data-rq-question]'));
    var total = questions.length;
    var nextBtn = root.querySelector('[data-rq-next]');
    var backBtn = root.querySelector('[data-rq-back]');
    var progress = root.querySelector('[data-rq-progress]');
    var quiz = root.querySelector('[data-rq-quiz]');
    var loader = root.querySelector('[data-rq-loader]');
    var reveal = root.querySelector('[data-rq-reveal]');
    var pkgStep = root.querySelector('[data-rq-package]');
    var statusLines = slice(root.querySelectorAll('[data-rq-status-line]'))
      .map(function (el) { return el.textContent.trim(); })
      .filter(Boolean);
    if (!total || !nextBtn || !backBtn || !progress) return;

    // Discount bar month = visitor's current month + year (same as radiancy-buy.js; server value stays as fallback).
    try {
      var month = new Date().toLocaleString('en-US', { month: 'long', year: 'numeric' });
      slice(root.querySelectorAll('[data-rb-month]')).forEach(function (el) { el.textContent = month; });
    } catch (e) { /* keep server value */ }

    var tiers = cfg.tiers || [];
    // reveal = card + button → checkout; checkout = add the Q5 pack to the cart right after the loader → /checkout
    // (VSL quiz); redirect = the buy page.
    var mode = cfg.mode === 'reveal' && reveal && tiers.length ? 'reveal'
      : cfg.mode === 'checkout' && tiers.length ? 'checkout' : 'redirect';
    var progressSteps = total + (pkgStep ? 0 : 1);
    var current = 1;
    var phase = 'quiz'; // quiz | loading | reveal | leaving
    var revealedOnce = false;
    var started = false;
    var stepsSent = {};

    function step(n) { return questions[n - 1]; }
    function isLast() { return current === total; }
    function checked(n) { return slice(step(n).querySelectorAll('input[data-rq-answer]:checked')); }

    function updateProgress() { progress.style.width = (current / progressSteps) * 100 + '%'; }
    function updateButton() { nextBtn.textContent = isLast() ? cfg.finalLabel : cfg.nextLabel; }
    function updateBack() { backBtn.style.display = current > 1 ? 'block' : 'none'; }
    var preloaded = false;
    var pkgTrust = root.querySelector('[data-rq-pkg-trust]');
    function show(n) {
      questions.forEach(function (q, i) { q.style.display = i === n - 1 ? 'block' : 'none'; });
      current = n;
      // Opt-in package-step trust (below the button): only while the package step shows.
      if (pkgTrust) pkgTrust.hidden = step(n) !== pkgStep;
      // Reaching the buy box: warm the reveal's pack images so the reveal paints complete.
      if (!preloaded && step(n) === pkgStep && reveal) {
        preloaded = true;
        (cfg.tiers || []).forEach(function (t) { if (t.img) { var im = new Image(); im.src = t.img; } });
      }
      updateProgress();
      updateButton();
      updateBack();
    }

    /* ---------- buy box (package step) ---------- */
    var subInput = root.querySelector('[data-rq-sub]');
    // Opt-in two-way toggle (sub_style = toggle): radios value 1 = Subscribe & Save, 0 = one-time.
    var subModes = slice(root.querySelectorAll('[data-rq-sub-mode]'));
    var subModeOn = subModes.filter(function (r) { return r.checked; })[0];
    var buy = { subscribe: subModes.length ? !!(subModeOn && subModeOn.value === '1') : (subInput ? subInput.checked : false) };
    function tierFor(bottles) {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].bottles === bottles) return tiers[i];
      return null;
    }
    function selectedTier() {
      var r = pkgStep && pkgStep.querySelector('input[name="rq-bottle"]:checked');
      return r ? tierFor(Number(r.value)) : null;
    }
    function priceOf(t) { return buy.subscribe ? t.subCents : t.oneTimeCents; }
    function perOf(t) { return Math.round(priceOf(t) / t.bottles); }
    // Per-pack shipping override (package settings ship_one_time / ship_subscribe), else the free-from rule.
    function shipOf(price, t) {
      var o = t && (buy.subscribe ? t.shipSubCents : t.shipOneCents);
      if (typeof o === 'number') return o;
      return price >= cfg.freeFromCents ? 0 : cfg.shipRateCents;
    }
    function pctOf(t) { return cfg.anchorCents > 0 ? Math.round(100 - (perOf(t) * 100) / cfg.anchorCents) : 0; }

    function renderBuy() {
      if (!pkgStep) return;
      var sel = selectedTier();
      // Opt-in [save] token in the subscribe label: the selected pack's saving off its one-time price, rounded down.
      if (sel) slice(document.querySelectorAll('[data-rq-save]')).forEach(function (el) { el.textContent = sel.oneTimeCents > 0 ? Math.floor(((sel.oneTimeCents - sel.subCents) * 100) / sel.oneTimeCents) : 0; });
      slice(pkgStep.querySelectorAll('[data-rq-card]')).forEach(function (card) {
        var t = tierFor(Number(card.getAttribute('data-bottles')));
        card.classList.toggle('is-selected', !!sel && t === sel);
        if (!t) return;
        var price = priceOf(t);
        var ship = shipOf(price, t);
        slice(card.querySelectorAll('[data-rq-card-pct]')).forEach(function (el) { el.textContent = pctOf(t); });
        slice(card.querySelectorAll('[data-rq-card-per]')).forEach(function (el) { el.textContent = money(perOf(t)); });
        slice(card.querySelectorAll('[data-rq-card-total]')).forEach(function (el) { el.textContent = money(price); });
        slice(card.querySelectorAll('[data-rq-card-ship]')).forEach(function (el) {
          el.textContent = ship ? fill(cfg.shipPaidCard, { rate: money(ship) }) : cfg.shipFreeCard;
        });
      });
      var lt = sel || tiers[0];
      if (lt) {
        slice(pkgStep.querySelectorAll('[data-rq-sub-qty]')).forEach(function (el) { el.textContent = lt.qty; });
        slice(pkgStep.querySelectorAll('[data-rq-sub-cadence]')).forEach(function (el) { el.textContent = lt.cadence; });
      }
      slice(pkgStep.querySelectorAll('[data-rq-sub-only]')).forEach(function (el) { el.hidden = !buy.subscribe; });
    }
    if (pkgStep) {
      pkgStep.addEventListener('change', function (e) {
        if (e.target === subInput) buy.subscribe = subInput.checked;
        if (subModes.indexOf(e.target) !== -1) buy.subscribe = e.target.value === '1';
        renderBuy();
      });
      renderBuy();
    }

    /* ---------- answers ---------- */
    function answerValue(n) {
      return checked(n).map(function (el) { return el.value; }).join(',');
    }
    function tagStep(n) {
      var q = step(n);
      clarity('set', q.getAttribute('data-rq-clarity') || 'quiz_q' + n, answerValue(n));
      if (q === pkgStep) clarity('set', 'quiz_subscribe', buy.subscribe ? 'yes' : 'no');
      if (!stepsSent[n]) { stepsSent[n] = true; clarity('event', 'quiz_step_' + n); }
    }

    // Clear a step's warning once answered; first answer anywhere = quiz_started.
    questions.forEach(function (q) {
      q.addEventListener('change', function (e) {
        if (!e.target.hasAttribute('data-rq-answer')) return;
        if (!started) { started = true; clarity('event', 'quiz_started'); }
        var warn = q.querySelector('[data-rq-warning]');
        if (warn && q.querySelector('input[data-rq-answer]:checked')) warn.style.display = 'none';
      });
    });

    nextBtn.addEventListener('click', function () {
      if (phase !== 'quiz') return;
      if (!checked(current).length) {
        var warn = step(current).querySelector('[data-rq-warning]');
        if (warn) warn.style.display = 'flex';
        return;
      }
      tagStep(current);
      if (!isLast()) { show(current + 1); return; }
      if (mode === 'reveal' && revealedOnce) { showReveal(); return; }
      startLoader();
    });

    function backToPackage(e) {
      if (e) e.preventDefault();
      if (phase !== 'reveal') return;
      phase = 'quiz';
      if (reveal) reveal.style.display = 'none';
      document.body.classList.remove('rq-revealed');
      quiz.style.display = '';
      nextBtn.style.display = '';
      backBtn.classList.remove('is-inert');
      show(total);
      var top = root.getBoundingClientRect().top + window.pageYOffset - 10;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
    }

    backBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (phase === 'reveal') { backToPackage(); return; }
      if (phase !== 'quiz' || current <= 1) return;
      show(current - 1);
    });

    function collectAnswers() {
      var params = [];
      var store = {};
      questions.forEach(function (q, i) {
        var key = q.getAttribute('data-rq-key') || 'q' + (i + 1);
        var inputs = checked(i + 1);
        var values = inputs.map(function (el) { return el.value; });
        var labels = inputs.map(function (el) { return el.getAttribute('data-label'); });
        params.push([key, values.join(',')]);
        store[key] = { question: q.getAttribute('data-rq-title') || '', answers: labels, values: values };
      });
      if (pkgStep) store.subscribe = buy.subscribe;
      return { params: params, store: store };
    }
    function saveAnswers(answers) {
      try {
        window.sessionStorage.setItem(cfg.storageKey || 'radiancy_quiz', JSON.stringify({
          answers: answers.store,
          completed_at: new Date().toISOString(),
          source: window.location.pathname
        }));
      } catch (e) { /* storage disabled */ }
    }

    function buildRedirect(params) {
      var base = new URL(cfg.redirect || '/', window.location.origin);
      var drop = String(cfg.dropParams || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var answerKeys = params.map(function (p) { return p[0]; });
      new URLSearchParams(incoming).forEach(function (value, key) {
        if (drop.indexOf(key) !== -1 || answerKeys.indexOf(key) !== -1) return;
        if (base.searchParams.has(key)) return;
        base.searchParams.append(key, value);
      });
      params.forEach(function (p) { base.searchParams.set(p[0], p[1]); });
      return base.origin === window.location.origin
        ? base.pathname + base.search + base.hash
        : base.toString();
    }

    /* ---------- loader ---------- */
    function startLoader() {
      phase = 'loading';
      var answers = collectAnswers();
      saveAnswers(answers);
      var redirectURL = mode === 'redirect' ? buildRedirect(answers.params) : '';
      if (redirectURL) root.setAttribute('data-rq-redirect', redirectURL);

      quiz.style.display = 'none';
      nextBtn.style.display = 'none';
      if (pkgTrust) pkgTrust.hidden = true;
      backBtn.classList.add('is-inert');
      loader.style.display = 'block';
      progress.style.width = '100%';

      var ring = loader.querySelector('[data-rq-ring]');
      var pct = loader.querySelector('[data-rq-pct]');
      var title = loader.querySelector('[data-rq-loader-title]');
      var status = loader.querySelector('[data-rq-status]');
      var circumference = 2 * Math.PI * 45;
      ring.style.strokeDasharray = circumference;
      ring.style.strokeDashoffset = circumference;
      pct.textContent = '0%';

      var target = Math.max(1, Math.min(100, Number(cfg.target) || 95));
      var duration = Math.max(500, Number(cfg.durationMs) || 2500);
      var hold = Math.max(0, Number(cfg.readyHoldMs) || 1000);
      var tick = duration / target;
      var value = 0;
      var lineIndex = 0;
      var t0 = Date.now();

      function setLine(i) {
        if (!statusLines.length || i === lineIndex) return;
        lineIndex = i;
        status.classList.add('is-fading');
        setTimeout(function () {
          status.textContent = statusLines[i];
          status.classList.remove('is-fading');
        }, 180);
      }
      if (statusLines.length) status.textContent = statusLines[0];

      // Driven by elapsed time, not tick count, so throttled timers (background tab, busy phone) still finish on time.
      var timer = setInterval(function () {
        var elapsed = Date.now() - t0;
        if (value < target) {
          var next = Math.min(target, Math.max(value + 1, Math.floor((elapsed / duration) * target)));
          if (elapsed < duration) next = Math.min(next, target - 1);
          value = next;
          pct.textContent = value + '%';
          ring.style.strokeDashoffset = circumference - (value / 100) * circumference;
          setLine(Math.min(statusLines.length - 1, Math.floor(elapsed / (duration / Math.max(1, statusLines.length)))));
          return;
        }
        clearInterval(timer);
        if (mode === 'checkout') {
          setTimeout(function () {
            title.textContent = cfg.readyTitle;
            status.classList.remove('is-fading');
            status.textContent = cfg.redirectingText;
            // No hold after the add: /checkout follows add.js at once (tracking law rule 2).
            addToCartThenCheckout(selectedTier(), function () {
              loader.style.display = 'none';
              phase = 'quiz';
              quiz.style.display = '';
              nextBtn.style.display = '';
              backBtn.classList.remove('is-inert');
              show(total);
              var warn = pkgStep && pkgStep.querySelector('[data-rq-warning]');
              if (warn) { warn.textContent = cfg.errorLabel || warn.textContent; warn.style.display = 'flex'; }
            });
          }, 300);
          return;
        }
        if (mode === 'reveal') {
          setTimeout(function () {
            loader.style.display = 'none';
            showReveal();
          }, 300);
          return;
        }
        setTimeout(function () {
          title.textContent = cfg.readyTitle;
          status.classList.remove('is-fading');
          status.textContent = cfg.redirectingText;
          setTimeout(function () {
            if (designMode) return; // never navigate away inside the theme editor
            phase = 'leaving';
            window.location.href = redirectURL;
          }, hold);
        }, 300);
      }, tick);
    }

    /* ---------- reveal ---------- */
    function renderReveal() {
      var t = selectedTier();
      if (!t || !reveal) return;
      var price = priceOf(t);
      var ship = shipOf(price, t);
      var set = function (sel, text) { var el = reveal.querySelector(sel); if (el) el.textContent = text; };
      var img = reveal.querySelector('[data-rq-r-img]');
      if (img) { img.src = t.img; img.alt = t.name; }
      set('[data-rq-r-name]', t.name);
      set('[data-rq-r-per]', fill(cfg.revealPer, { qty: t.qty, per: money(perOf(t)) }));
      set('[data-rq-r-anchor]', cfg.anchorCents > 0 ? money(cfg.anchorCents * t.bottles) : '');
      set('[data-rq-r-total]', money(price));
      set('[data-rq-r-plan]', buy.subscribe ? fill(cfg.revealSub, { cadence: t.cadence, qty: t.qty }) : cfg.revealOne);
      reveal.setAttribute('data-subscribe', buy.subscribe ? '1' : '0');
      set('[data-rq-r-ship]', ship ? fill(cfg.revealShipPaid, { rate: money(ship) }) : cfg.revealShipFree);
    }
    function showReveal() {
      phase = 'reveal';
      renderReveal();
      quiz.style.display = 'none';
      loader.style.display = 'none';
      nextBtn.style.display = 'none';
      backBtn.classList.remove('is-inert');
      backBtn.style.display = 'block';
      progress.style.width = '100%';
      reveal.style.display = 'block';
      document.body.classList.add('rq-revealed');
      if (!revealedOnce) { revealedOnce = true; clarity('event', 'quiz_completed'); }
      var top = root.getBoundingClientRect().top + window.pageYOffset - 10;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
    }

    /* ---------- checkout ---------- */
    var pristineFetch = null;
    function quietPost(path, init, body) {
      // Same as radiancy-buy.js: requests nothing should observe (the cart clear, the $0 display line) go through a
      // hidden blank iframe's fetch, which Shopify's product_added_to_cart instrumentation does not wrap.
      if (!pristineFetch) {
        try {
          var frame = document.createElement('iframe');
          frame.setAttribute('aria-hidden', 'true');
          frame.tabIndex = -1;
          frame.style.display = 'none';
          document.body.appendChild(frame);
          pristineFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
        } catch (e) {
          pristineFetch = window.fetch.bind(window);
        }
      }
      return pristineFetch(window.location.origin + path, {
        method: init.method, credentials: init.credentials, headers: init.headers, body: body
      });
    }
    function okJson(what) {
      return function (r) { if (!r.ok) throw new Error(what + ' ' + r.status); return r.json(); };
    }
    // Free-bottle line: only when the section names the $0 variant and the pack has free bottles.
    function freeItem(t) {
      if (!cfg.freeVariantId || !(t.free > 0)) return null;
      var item = { id: Number(cfg.freeVariantId), quantity: t.free };
      if (cfg.freeProp && t.name) { item.properties = {}; item.properties[cfg.freeProp] = t.name; }
      return item;
    }
    // Checkout-visible notes under the paid line, in display order: bottle count, savings, guarantee.
    function paidProps(t, withFree) {
      var props = {};
      if (cfg.lineProp) {
        if (withFree && cfg.lineFree) props[cfg.lineProp] = fill(cfg.lineFree, { paid: t.bottles - t.free, free: t.free, total: t.bottles });
        else if (t.qty) props[cfg.lineProp] = t.qty;
      }
      // Savings = the variant's compare-at (else its one-time price, e.g. Buy One on subscribe) minus the price paid.
      var save = (t.compareCents > 0 ? t.compareCents : t.oneTimeCents) - priceOf(t);
      if (cfg.saveProp && save > 0) props[cfg.saveProp] = money(save);
      if (cfg.guaranteeProp && cfg.guaranteeText) props[cfg.guaranteeProp] = cfg.guaranteeText;
      return Object.keys(props).length ? props : null;
    }
    function muteUpCart() {
      try {
        var s = window.upcartSettings && window.upcartSettings.upcartSettings;
        if (s) s.openOnAddToCart = false;
      } catch (e) { /* app not present */ }
    }
    function checkoutUrl() {
      var keep = String(cfg.carryParams || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var out = new URLSearchParams();
      new URLSearchParams(incoming).forEach(function (value, key) {
        if (keep.indexOf(key) !== -1 || /^utm_/.test(key)) out.append(key, value);
      });
      var qs = out.toString();
      return '/checkout' + (qs ? '?' + qs : '');
    }

    // Every checkout button runs checkout() and shares one busy/error/bfcache state: the reveal card's button plus
    // [data-rb-checkout] buttons from the buy-page sections (reviews). Their label mirrors the reveal button's.
    var cta = reveal && reveal.querySelector('[data-rq-checkout]');
    var ctas = cta ? [cta].concat(slice(document.querySelectorAll('[data-rb-checkout]'))) : [];
    function labelOf(btn) { return btn.querySelector('.rb-cta__label') || btn; }
    var ctaText = cta ? labelOf(cta).textContent : '';
    ctas.forEach(function (btn) { labelOf(btn).textContent = ctaText; });
    function setCtas(disabled, text) {
      ctas.forEach(function (btn) { btn.disabled = disabled; labelOf(btn).textContent = text; });
    }
    var busy = false;
    function checkout() {
      if (busy || phase !== 'reveal') return;
      var t = selectedTier();
      if (!t) return;
      clarity('event', 'quiz_checkout_click');
      if (designMode) return; // no cart writes from the theme editor
      setCtas(true, cfg.loadingLabel || ctaText);
      addToCartThenCheckout(t, function () {
        setCtas(false, cfg.errorLabel || ctaText);
        setTimeout(function () { if (!busy) setCtas(false, ctaText); }, 4000);
      });
    }
    // One add path for the reveal button and checkout mode: clear (quiet) → optional $0 free line (quiet) → the paid
    // pack through the page's own window.fetch (Meta AddToCart; tracking law rule 1) → /checkout at once (rule 2).
    function addToCartThenCheckout(t, onFail) {
      if (busy || !t) return;
      if (designMode) return; // no cart writes from the theme editor
      busy = true;
      phase = 'leaving';

      var item = { id: Number(t.variantId), quantity: 1 };
      if (buy.subscribe && t.planId) item.selling_plan = Number(t.planId);
      var free = freeItem(t);
      var props = paidProps(t, !!free);
      if (props) item.properties = props;
      window.__rqLastAdd = free ? [item, free] : item;
      saveAnswers(collectAnswers());
      var init = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

      muteUpCart();
      quietPost('/cart/clear.js', init)
        .then(okJson('clear'))
        .then(function () {
          // The free bottle ships inside the pack SKU, so a failed $0 display line must never block the sale.
          if (!free) return null;
          return quietPost('/cart/add.js', init, JSON.stringify({ items: [free] }))
            .then(function (r) { if (!r.ok && window.console) console.warn('[rq] free line skipped', r.status); })
            .catch(function (e) { if (window.console) console.warn('[rq] free line skipped', e); });
        })
        .then(function () {
          muteUpCart();
          return window.fetch('/cart/add.js', {
            method: init.method, credentials: init.credentials, headers: init.headers,
            body: JSON.stringify({ items: [item] })
          });
        })
        .then(okJson('add'))
        .then(function () {
          try { if (window.VSLTrack && window.VSLTrack.checkout) window.VSLTrack.checkout(t.bottles); } catch (e) {}
          window.location.href = checkoutUrl();
        })
        .catch(function (err) {
          if (window.console) console.error('[rq] checkout failed', err);
          busy = false;
          phase = mode === 'reveal' ? 'reveal' : 'quiz';
          onFail();
        });
    }
    ctas.forEach(function (btn) { btn.addEventListener('click', checkout); });
    var change = reveal && reveal.querySelector('[data-rq-change]');
    if (change) change.addEventListener('click', backToPackage);

    // Back/forward cache: restored from the checkout → button usable again, reveal still showing.
    window.addEventListener('pageshow', function (e) {
      // Checkout mode, back from the checkout: return to the pack step, ready to go again.
      if (e.persisted && mode === 'checkout' && phase === 'leaving') {
        busy = false;
        phase = 'quiz';
        loader.style.display = 'none';
        quiz.style.display = '';
        nextBtn.style.display = '';
        backBtn.classList.remove('is-inert');
        show(total);
        return;
      }
      if (!e.persisted || !ctas.length) return;
      busy = false;
      if (phase === 'leaving') phase = 'reveal';
      setCtas(false, ctaText);
    });

    // Theme editor: selecting a question/package block shows that step.
    if (designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!root.contains(e.target) || phase !== 'quiz') return;
        var idx = questions.indexOf(e.target.closest('[data-rq-question]'));
        if (idx !== -1) show(idx + 1);
      });
    }
  }

  function initAll(scope) {
    slice((scope || document).querySelectorAll('[data-rq]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  // Theme editor: selecting one of the reveal's buy-page sections (hidden until the reveal) shows them while selected.
  if (window.Shopify && window.Shopify.designMode) {
    var isAfter = function (el) { return el && el.classList && (el.classList.contains('rb-col-main') || el.classList.contains('rb-col-side')); };
    document.addEventListener('shopify:section:select', function (e) {
      if (isAfter(e.target)) document.body.classList.add('rq-edit-after');
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (isAfter(e.target)) document.body.classList.remove('rq-edit-after');
    });
  }
})();
